import { Component, OnInit } from '@angular/core';
import { DashboardWidgetContent, DashboardWidgetLookup } from '@serengeti/serengeti-dashboard';

@DashboardWidgetLookup('WizardOrderStatComponent')
@Component({
  selector: 'app-wizard-order-stat',
  templateUrl: './wizard-order-stat.component.html',
  styleUrls: ['./wizard-order-stat.component.scss']
})
export class WizardOrderStatComponent implements OnInit, DashboardWidgetContent {

  constructor() { }

  property(): boolean {
    return true;
  }

  configure(setting: any): void {
  }

  ngOnInit() {
  }

}
